import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>

			
			{/* <Popup /> */}
			
			<Slider />


			<div className="container" style={{display:'flex',width:'100%',marginBottom:'25px'}}>
			<div className="col-md-2" style={{background:'orange',color:'maroon',display:'flex',alignItems:'center',justifyContent:'center',borderRadius:'0px 0px 15px 15px'}}>
				<h4 style={{fontWeight:'600',color:'maroon'}}>Latest Updates</h4>
			</div>
			<div className="col-md-10" style={{background:'maroon',padding:'5px',borderRadius:'0px 0px 15px 15px',display:'flex',alignItems:'middle'}}>
				<Marquee speed={50} gradient={false} pauseOnHover>
					<div class="news_post_title" style={{padding:'0px'}}><p style={{color:'white',fontSize:'12pt'}}><a href="./images/pop-up-1.jpeg" style={{color:'white',fontSize:'12pt'}}>Hanuman Jayanthi Aakhosham - April 2, 2026, Thursday (Meenam - 19)</a></p></div>
				</Marquee>
			</div>
	  </div>
	  <marquee></marquee>
			<div class="booking-container">

				{/* <!-- SINGLE DAY --> */}
				<div class="booking-box single">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2972/2972357.png" alt="Single Day Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Single Day Pooja</h3>
					<p>Book pooja for a specific auspicious day with full temple rituals.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.makreritemple.in/">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				{/* <!-- MULTIPLE DAY --> */}
				<div class="booking-box multiple">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Multiple Day Pooja</h3>
					<p>Schedule pooja services for several days or festivals.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.makreritemple.in/multiple.aspx">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				{/* <!-- E-KANIKKA --> */}
				<div class="booking-box ekanikka">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2331/2331944.png" alt="e-kanikka" />
					</div>
					<h3 className="books-3-ways">E-Kanikka</h3>
					<p>Offer digital donations securely to the deity from anywhere.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.makreritemple.in/Donation.aspx">
							Donate Now <span>➜</span>
						</a>
					</div>

				</div>

			</div>

			<div className="row">
				{/* <LatestNews /> */}
			</div>

			<div className="row">

				<div className="col-12 col-md-8" style={{marginBottom:'50px'}}>

					{/* <p className="about" >
						ദേശത്തിന്റെ ആത്മചൈതന്യമായി അനുഗ്രഹം ചൊരിഞ്ഞു നിൽക്കുന്ന അമ്മമാരായ ദുർഗ്ഗാ ദേവിയും വാരാഹി പഞ്ചമിദേവിയും തുല്യ പ്രാധാന്യത്തോടെ കുടികൊള്ളുന്ന ശ്രീ പഞ്ചമി ദേവി ക്ഷേത്രത്തിന് അഞ്ചുനൂറ്റാണ്ടോളം പഴക്ക മുള്ളതായി പറയപ്പെടുന്നു. ആദിപരാശക്തിയായ ദേവിയുടെ സർവ്വസൈന്യാധിപയാണ് സപ്ത‌ മാതൃക്കളിൽ അഞ്ചാമത്തേതായ വാരാഹി പഞ്ചമിദേവി. അത്തരത്തിൽ ദുർഗ്ഗാദേവിയും വാരാഹി പഞ്ചമിദേവിയും വലതും ഇടതുമായി ചൈതന്യം ചൊരിഞ്ഞുനിൽക്കുന്ന ക്ഷേത്രം ഒരു പക്ഷേ ലോകത്തിൽതന്നെ മറ്റെങ്ങും ഉണ്ടാകാൻ ഇടയില്ല. വാരാഹി പഞ്ചമിദേവിയെ വൈഷ്‌ണവ-ശൈവ-ശാക്തേയ രീതികളിൽ പൂജിക്കാമെന്ന പ്രത്യേകതയുമുണ്ട്. <br />

						തെക്കത് സമ്പ്രദായത്തിലാണ് ആദ്യകാലത്ത് ദേവിയെ ആരാധിച്ചു വന്നത്. പീഠവും വാളു മായിരുന്നു അന്നത്തെ പ്രതിഷ്ഠ. വർഷത്തിൽ ഒരു ദിവസം നടക്കുന്ന കൊടുതി  (ഉത്സവം) അക്കാലത്ത് ഒരു സമൂഹത്തിന്റെയാകെ കൂട്ടായ്‌മ വിളംബരം ചെയ്യുന്നതായിരുന്നു. കൊടുതിയുടെ അന്ന് ഉച്ചയ്ക്ക് നടക്കുന്ന പന്തിരുനാഴി പൂജയായിരുന്നു പ്രധാന വഴിപാട്.
					</p> */}
					<div className="">
						<div className="row">
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/ram.png"/>
											</div>
										</div>
										<div className="col-md-9">
											<div className="frontbox">
												<p className="historyheadeg">ഐതിഹ്യം</p>
												<p className="frame-1-p">
													ത്രേതായുഗത്തിൽ ബാലിവധത്തിനുശേഷം ശ്രീരാമ ലക്ഷ്മണന്മാർ സീതാന്വേഷണാർത്ഥം സഞ്ചരിക്കവേ ഇന്ന് പെരളശ്ശേരിയെന്ന് പ്രസിദ്ധമായി തീർന്ന പ്രദേശത്തെത്തിച്ചേർന്നു. പ്രകൃതി സുന്ദരവും പരിപാവനത്ത്വം നിറഞ്ഞതുമായ ആ പ്രദേശത്ത് ഭക്തജനങ്ങളുടെ നന്മയ്ക്കായും ഭഗവാന്റെ ആഗമന സ്മരണയ്ക്കായും അവിടെയൊരു ദേവപ്രതിഷ്ഠ നടത്തണമെന്ന് ഹനുമാൻ ശ്രീരാമസ്വാമിയോടപേക്ഷിച്ചു. ഭക്തദാസനായ ഭഗവാനാകട്ടെ, തന്റെ ഭക്തന്റെ അപേക്ഷ സ്വീകരിക്കുകയും പ്രതിഷ്ഠാർത്ഥം കൈലാസത്തോളം ചെന്ന് പരമേശ്വരാനുമതിയോടെ ദേവസേനാപതിയായ ശ്രീ സുബ്രഹ്മണ്യന്റെ വിഗ്രഹം കൊണ്ടു വരുവാനായി ഹനുമാനോട് കല്പിക്കുകയും ചെയ്തു. ഹനുമാൻ തിരിച്ചെത്തുമ്പോഴേക്കും പ്രതിഷ്ഠയ്ക്കനുയോജ്വമായ ഉത്തമ മുഹൂർത്തം കഴിഞ്ഞുപോകുമെന്ന് മനസ്സിലാക്കി ശ്രീരാമസ്വാമി തന്റെ കൈയ്യിലുള്ള പെരുവളയൂരി ശ്രീ സുബ്രഹ്മണ്യ സങ്കല്പം ചെയ്ത് യഥാവിധി പ്രതിഷ്ഠിച്ചു. ശ്രീരാമന്റെ പെരുവള പ്രതിഷ്ഠിക്കപ്പെട്ട ദേശമാകയാൽ 'പെരുവളശ്ശേരി' യെന്നും, ക്രമേണ 'പെരളശ്ശേരി'യെന്നും ആ ദേശം പ്രസിദ്ധമായി. ശ്രീരാമൻ പ്രതിഷ്ഠ കഴിച്ച് അല്പനേരത്തിനുള്ളിൽ സുബ്രഹ്മണ്യ വിഗ്രഹവുമായി ഹനുമാൻ മനോവേഗത്തിൽ പറന്നെത്തി. താനെത്തുമ്പോഴേക്കും പ്രതിഷ്ഠ കഴിഞ്ഞത് കണ്ട് പശ്ചാത്താപഭരിതനായിത്തീർന്ന ഹനുമാനെ സമാശ്വസിപ്പിക്കാനായി താൻ കൊണ്ടുവന്ന സ്കന്ദവിഗ്രഹത്തെ അല്പം വടക്കുമാറി പ്രതിഷ്ഠിക്കാൻ ഹനുമാനോട് ശ്രീരാമൻ നിർദ്ദേശിച്ചു. ഇപ്രകാരം ശ്രീരാമ ലക്ഷ്മണന്മാരുടെ മഹനീയ സാന്നിദ്ധ്യത്തിൽ സാക്ഷാൽ ഹനുമാനാൽ പ്രതിഷ്ഠിക്കപ്പെട്ടതാണ് മക്രേരിയിലെ ശ്രീ സുബ്രഹ്മണ്യ പ്രതിഷ്ഠ. മർക്കട ശ്രേഷ്ഠന്മാരായ ഹനുമത്സുഗ്രീവാദികൾ താമസിച്ച ദേശം അഥവാ ചേരി എന്നർത്ഥത്തിൽ 'മർക്കടശ്ശേരി' എന്നും കാലാന്തരത്തിൽ ലോപിച്ച് 'മക്രേരി' എന്നും ഈ പ്രദേശം പ്രസിദ്ധമായി. ഇതാണ് ക്ഷേത്ര സംബന്ധമായ ഐതിഹ്യം.
												</p>
												
												{/* <Link to="/history"  className="btn btn-warning pos">Read More</Link> */}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/ram.png" />
											</div>
										</div>
										<div className="col-md-9">
											<div>
												<p className="historyheadeg">ശ്രീ മക്രേരി ക്ഷേത്രവും ജീർണ്ണോദ്ധാരണ പ്രവർത്തനങ്ങളും</p>
												<p className="frame-1-p">
													ആർഷ ഭാരത സംസ്‌കാരത്തിൻ്റെ ഭാഗമായി ലോകനന്മയെ മുൻനിർത്തി ക്കൊണ്ടും ജനങ്ങളുടെ ഭാവിശ്രേയസ്സിന്നുതകുമാറും ഋഷീശ്വരന്മാരും അവതാര പുരുഷന്മാരും ദേവതാരാധനയ്ക്കനുയോജ്യമായ നിരവധി ദേവാലയങ്ങൾ ഭാരത ത്തിലെങ്ങും സ്ഥാപിച്ചിട്ടുണ്ട്.
												</p>
												<Link to="/Activities"  className="btn btn-warning pos">Read More</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/ram.png" />
											</div>
										</div>
										<div className="col-md-9">
											<div>
												<p className="historyheadeg">സുബ്രഹ്മണ്യ സങ്കല്പ്‌പം</p>
												<p className="frame-1-p">
													സ്ക‌ന്ദപുരാണത്തിൽ സുബ്രഹ്മണ്യ ഉൽപ്പത്തിയെപ്പറ്റി പ്രതിപാദിക്കുന്നുണ്ട്. താരകാസുരവധത്തിനായി ദേവസേനാനിയായി സുബ്രഹ്മണ്യൻ ശിവപുത്രനായി പിറന്നു.
												</p>
												<Link to="/Imagination"  className="btn btn-warning pos">Read More</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-12 col-md-4" style={{ backgroundImage: 'url(./images/makreri-right.webp)', padding: '5px', backgroundSize: 'cover', backgroundPosition: 'center',backgroundAttachment:'fixed' }}>

				</div>
			</div>
		</div>

	);
}

export default Home;